import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  userId: number;
}

export function useDeleteUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ userId }: Params) =>
      del({
        url: `/users/${userId}`,
      }),
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUsers(false),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUsers(true),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUser(userId.toString()),
      });
    },
  });

  const deleteUser = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
